import { SxProps, Theme } from '@mui/material';

export const AccountTabsButtonSX =
	(select: boolean): SxProps<Theme> =>
	() => ({
		backgroundColor: select ? '#F0F7FF' : '#fff',
		border: select ? '2px solid #2682E7' : '1px solid #C9C9C9',
		color: select ? '#2682E7' : '#2C2C2C',
		fill: select ? '#2682E7' : '#2C2C2C',
		stroke: select ? '#2682E7' : '#2C2C2C',
		height: '120px',
		minWidth: '170px',
		width: '170px',
		display: 'flex',
		flexDirection: 'column',
		gap: 1,
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: 1.5,

		'&:hover': {
			backgroundColor: '#F0F7FF',
			border: '2px solid #2682E7',
			color: '#2682E7',
			fill: '#2682E7',
			stroke: '#2682E7',
		},
		'&:active': {
			backgroundColor: '#F0F7FF',
			border: '2px solid #2682E7',
			color: '#2682E7',
			fill: '#2682E7',
			stroke: '#2682E7',
		},
	});

export const AccountTabsNameSX: SxProps<Theme> = ({
	fontSize: 'var(--font-size-default)',
});
